import './Footer.css';
import { FaRegClock } from "react-icons/fa6";
import { PiPhoneDuotone } from "react-icons/pi";
import { GoDotFill } from "react-icons/go";
import { useTranslation } from 'react-i18next';
import { FaFacebook } from "react-icons/fa";


import { useNavigate } from 'react-router-dom';

function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <footer className='padding footer-div'>
      <div className='footer-content'>
        <div className='legal'>
          <h3>{t('legal.company_name')}</h3>
          <p>{t('legal.description')}</p>
          <a href={t('legal.anpc_link')} className='anpc' target='_blank' rel='noopener noreferrer' aria-label="ANPC - Autoritatea Națională pentru Protecția Consumatorilor">ANPC</a>
          <a href={t('legal.litigii_link')} className='litigii' target='_blank' rel='noopener noreferrer' aria-label="Soluționarea Alternativă a Litigiilor">SAL</a>
        </div>
        <nav aria-label="Linkuri utile">
          <ul className='linkuri-footer'>
            <p>{t('useful_links.title')}</p>
            <li><button type="button" className='footer-link-btn' onClick={()=>{navigate('/')}}><GoDotFill className='orange-dot' aria-hidden="true" />{t('useful_links.home')}</button></li>
            <li><button type="button" className='footer-link-btn' onClick={()=>{navigate('/despre')}}><GoDotFill className='orange-dot' aria-hidden="true" />{t('useful_links.about_us')}</button></li>
            <li><button type="button" className='footer-link-btn' onClick={()=>{navigate('/servicii')}}><GoDotFill className='orange-dot' aria-hidden="true" />{t('useful_links.services')}</button></li>
            <li><button type="button" className='footer-link-btn' onClick={()=>{navigate('/contact')}}><GoDotFill className='orange-dot' aria-hidden="true" />{t('useful_links.contact')}</button></li>
          </ul>
        </nav>
        <nav aria-label="Servicii">
          <ul className='servicii-footer'>
            <p>{t('services.title')}</p>
            <li><button type="button" className='footer-link-btn' onClick={()=>{navigate('/servicii')}}><GoDotFill className='orange-dot' aria-hidden="true" />{t('services.architecture')}</button></li>
            <li><button type="button" className='footer-link-btn' onClick={()=>{navigate('/servicii')}}><GoDotFill className='orange-dot' aria-hidden="true" />{t('services.structural_engineering')}</button></li>
            <li><button type="button" className='footer-link-btn' onClick={()=>{navigate('/servicii')}}><GoDotFill className='orange-dot' aria-hidden="true" />{t('services.installations')}</button></li>
            <li><button type="button" className='footer-link-btn' onClick={()=>{navigate('/servicii')}}><GoDotFill className='orange-dot' aria-hidden="true" />{t('services.specialized_studies')}</button></li>
          </ul>
        </nav>
        <div className='contact-footer'>
          <p>{t('contact-footer.title')}</p>
          <p style={{display:'flex', columnGap:'8px'}}><FaRegClock className='orange-dot scale2' aria-hidden="true" />{t('contact-footer.working_hours')}</p>
          <p>{t('contact-footer.weekend_closed')}</p>
          <div style={{display:'flex', alignItems:'center'}}><PiPhoneDuotone className='orange-dot scale' aria-hidden="true" /><a href={`tel:${t('contact-footer.phone')}`} className='tel'>{t('contact-footer.phone')}</a></div>
          <a href="https://www.facebook.com/profile.php?id=61555676706565" target='_blank' rel='noopener noreferrer' aria-label="Pagina Facebook Daimond Expert"><FaFacebook className='facebook' aria-hidden="true" /></a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;